import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index.vue";
import AuthSuccess from "@views/AuthSuccess";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import Loading from "@views/Loading";
import IFrame from "@components/IFrame";

Vue.use(Router);
// 获取原型对象push函数
const originalPush = Router.prototype.push;

// 获取原型对象replace函数
const originalReplace = Router.prototype.replace;

// 修改原型对象中的push函数
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      meta: {
        title: "首页",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: Index,
    },
    {
      path: "/authSuccess",
      name: "authSuccess",
      meta: {
        title: "授权成功",
        keepAlive: false,
      },
      component: AuthSuccess,
    },
    {
      path: "/iframe",
      name: "IFrame",
      component: IFrame,
      meta: {
        title: "游戏",
        keepAlive: false,
      },
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true,
      },
      component: Loading,
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB",
      },
      component: NotDefined,
    },
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  },
});

const { back, replace } = router;

router.back = function () {
  this.isBack = true;
  back.call(router);
};
router.replace = function (...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  const { title, backgroundColor, footer, home, auth } = to.meta;
  // console.log(to.name, form.name);
  if (auth === true && !$store.state.app.token) {
    if (form.name === "Login") return;
    return toLogin(true, to.fullPath);
  }
  document.title = title || process.env.VUE_APP_NAME || "yshop商城";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

export default router;
